<template>
  <div class="login_back">
    <div class="container">
      <div class="row justify-content-center align-items-center row-login">
        <div class="col-md-4">
          <b-form @submit.prevent="authLogin" class="form-login">
            <div class="text-center login-title">永豐網路平台</div>

            <hr/>
            <b-form-group label-cols="2" label="帳號">
              <b-input v-model="form.email" required></b-input>
            </b-form-group>
            <b-form-group label-cols="2" label="密碼">
              <b-input v-model="form.password" type="password" required></b-input>
            </b-form-group>
            <b-row>
              <b-col>
                <b-button
                  type="submit"
                  variant="primary"
                  class="btn-login"
                >
                  登入
                </b-button>
              </b-col>
            </b-row>

            <hr/>



          </b-form>

          <b-tabs v-model="tab.tabIndex" class="mb-4">
            <b-tab
              v-for="(item, index) in tab.items"
              :key="index"
              :title="item.label" />
          </b-tabs>

          <template v-if="tab.tabIndex === 0">
            <b-card
              border-variant="info"
              header="要助人登入"
              header-bg-variant="info"
              header-text-variant="white"
              align="left"
              class="mb-4"
            >
              <div>帳號：身分證字號</div>
              <div>密碼：預設密碼為出生年月日，例如民國20年3月8日生，則輸入200308</div>
            </b-card>
          </template>

          <template v-if="tab.tabIndex === 1">
            <b-card
              border-variant="success"
              header="業務組織登入"
              header-bg-variant="success"
              header-text-variant="white"
              align="left"
              class="mb-4"
            >
              <div>帳號：身分證字號</div>
              <div>密碼：預設密碼為手機號碼，例如：0912345678</div>
            </b-card>
          </template>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseApi from "@/models/API/baseApi";
import { setLocalUserInfo } from "@/models/HELPERS/common.js";

export default {
  name: 'login',
  data() {
    return {
      form: {
        email:'',
        password:''
      },
      tab: {
        items: [
          {
            label: '要助人',
            value: 0
          },
          {
            label: '業務組織',
            value: 1
          },
        ],
        tabIndex: 0
      }
    }
  },
  mounted() {
    this.baseApi = new baseApi();
  },
  methods: {
    // 登入後台
    authLogin() {
      this.baseApi.authLogin((response) => {
        const res = response.data;

        if (res.error) {
          const result = { message: '帳號或密碼錯誤!!', title: '登入' };
          this.baseApi.toast(() => {}, result, false);
        } else {
          const save_data = {
            user_id: res.id,
            token: res.access_token,
            account: this.form.email,
            authority: res.authority,
            name: res.name,
            permission: res.permission
          }

          setLocalUserInfo(res.authority, save_data);
          const redirection = this.$route.query.redirection;
          // 允許的 router name
          const validRoutes = ["Pay"];
          // 要助人登入目標router
          const toHelpingOthersTargetRoute = (redirection && validRoutes.includes(redirection)) ? { name: redirection } : '/backstage/toHelpingOthers/dashboard';

          switch(res.authority) {
            case 1:
              this.$router.push('/backstage/yf/dashboard');
              break;
            case 2:
              this.$router.push(toHelpingOthersTargetRoute);
              break;
            case 3:
              this.$router.push('/backstage/businessInfo/dashboard');
              break;
          }
        }
      }, this.form)
    },
  }
}
</script>
<style lang="scss" scoped>
.login-title{
  font-size: 1.6rem;
  font-weight: 600;
}
.login_back{
  background-image: url("~@/assets/img/login/back_login.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: rgba(0, 0, 0, .5);
  background-blend-mode: multiply;
}
.card-header{
  text-align: center;
}

.row-login{
    height:100vh;
    .col-md-4{
      background-color: #F0F0F0;
      padding: 10px;
        .form-login{
            margin: 10px;
        }
    }
}
.btn-login{
    width: 100%;
}
.input-group .input-group-text {
    width: 140px;
}
.input-countryCode{
    max-width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/Home/Login.vue